import { render, staticRenderFns } from "./AttendeeCard.vue?vue&type=template&id=61051e51&lang=pug"
import script from "./AttendeeCard.vue?vue&type=script&lang=js"
export * from "./AttendeeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports